import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadConfigurationAction, SearchPrioritiesAction } from '../state/actions';
import { AuthService } from '../auth/auth.service';
import { adminMenuItems, customerMenuItems, editorMenuItems, externalMenuItems } from './menu';
import { GlobalState } from '../state';
import { ChatState } from '../chat/state';
import { filter } from 'rxjs';
import { SetChatVisibilityAction } from '../chat/state/actions';
import { environment } from '../../environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../auth/auth.service";
import * as i3 from "@angular/router";
import * as i4 from "primeng/button";
import * as i5 from "primeng/api";
import * as i6 from "@angular/common";
import * as i7 from "primeng/menubar";
import * as i8 from "primeng/tooltip";
import * as i9 from "primeng/panelmenu";
import * as i10 from "primeng/drawer";
import * as i11 from "../chat/chat-window/chat-window.component";
const _c0 = () => ["/organizer"];
function BaseComponent_Conditional_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 5);
} if (rf & 2) {
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(1, _c0));
} }
function BaseComponent_Conditional_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵelement(2, "img", 8);
    i0.ɵɵelementStart(3, "div", 9)(4, "span", 10);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 11);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "button", 12);
    i0.ɵɵlistener("click", function BaseComponent_Conditional_0_ng_template_2_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.logout()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r1.me.image, i0.ɵɵsanitizeUrl)("alt", ctx_r1.me.title);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.me.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.me.eMail);
} }
function BaseComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-menubar", 1);
    i0.ɵɵtemplate(1, BaseComponent_Conditional_0_ng_template_1_Template, 1, 2, "ng-template", 2)(2, BaseComponent_Conditional_0_ng_template_2_Template, 9, 4, "ng-template", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "main", 4);
    i0.ɵɵelement(4, "router-outlet");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("model", ctx_r1.items);
} }
function BaseComponent_Conditional_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("mouseleave", function BaseComponent_Conditional_1_ng_template_2_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.toggleDrawer(false)); });
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵelement(2, "img", 8);
    i0.ɵɵelementStart(3, "div", 17)(4, "span", 18);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementStart(7, "span", 11);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 19)(10, "p-button", 20);
    i0.ɵɵlistener("click", function BaseComponent_Conditional_1_ng_template_2_Template_p_button_click_10_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.router.navigate(["/orders/new"])); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "p-button", 21);
    i0.ɵɵlistener("click", function BaseComponent_Conditional_1_ng_template_2_Template_p_button_click_11_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.router.navigate(["/organizer"])); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "p-button", 22);
    i0.ɵɵlistener("click", function BaseComponent_Conditional_1_ng_template_2_Template_p_button_click_12_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.router.navigate(["/organizer/cal"])); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "p-button", 23);
    i0.ɵɵlistener("click", function BaseComponent_Conditional_1_ng_template_2_Template_p_button_click_13_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.router.navigate(["/clip"])); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 24);
    i0.ɵɵelement(15, "p-panelMenu", 1)(16, "hr")(17, "p-panelMenu", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 25)(19, "p-button", 26);
    i0.ɵɵlistener("click", function BaseComponent_Conditional_1_ng_template_2_Template_p_button_click_19_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.logout()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r1.me.image, i0.ɵɵsanitizeUrl)("alt", ctx_r1.me.title);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.me.title);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.me.eMail);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("model", ctx_r1.speeddialItems);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("model", ctx_r1.items);
} }
function BaseComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 13);
    i0.ɵɵlistener("mouseenter", function BaseComponent_Conditional_1_Template_p_button_mouseenter_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleDrawer(true)); })("click", function BaseComponent_Conditional_1_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleDrawer(true)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "p-drawer", 14);
    i0.ɵɵtwoWayListener("visibleChange", function BaseComponent_Conditional_1_Template_p_drawer_visibleChange_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.visible, $event) || (ctx_r1.visible = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵtemplate(2, BaseComponent_Conditional_1_ng_template_2_Template, 20, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "main", 4);
    i0.ɵɵelement(5, "router-outlet");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("visible", ctx_r1.visible);
    i0.ɵɵproperty("dismissible", true);
} }
function BaseComponent_Conditional_2_i_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 29);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("click", function BaseComponent_Conditional_2_i_1_Template_i_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.setChatVisibility(true)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("new-message", true === i0.ɵɵpipeBind1(1, 2, ctx_r1.hasNew$));
} }
function BaseComponent_Conditional_2_mvm_chat_window_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mvm-chat-window");
} }
function BaseComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BaseComponent_Conditional_2_i_1_Template, 2, 4, "i", 27);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, BaseComponent_Conditional_2_mvm_chat_window_3_Template, 1, 0, "mvm-chat-window", 28);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", false === i0.ɵɵpipeBind1(2, 2, ctx_r1.chatVisible$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx_r1.chatVisible$));
} }
export class BaseComponent {
    store;
    authService;
    router;
    items = [];
    me;
    chatVisible$ = inject(Store).select(ChatState.visible);
    hasNew$ = inject(Store).select(ChatState.hasNew);
    environment = environment;
    showSpeeddial = false;
    speeddialItems = [
        {
            label: 'Organizator',
            icon: 'fa-solid fa-table',
            command: () => this.router.navigate(['/organizer']),
        },
        {
            label: 'Naročila',
            icon: 'fa-solid fa-cart-shopping',
            command: () => this.router.navigate(['/orders']),
        },
        {
            label: 'Opravila',
            icon: 'fa-solid fa-tasks',
            command: () => this.router.navigate(['/tasks']),
        },
        {
            label: 'CRM',
            icon: 'fa-solid fa-user-tie',
            command: () => this.router.navigate(['/inbox/dashboard']),
        },
        {
            label: $localize `Statistike`,
            icon: 'fa-solid fa-chart-pie',
            routerLink: '/dashboard'
        },
    ];
    visible = false;
    layout = environment.layout;
    constructor(store, authService, router) {
        this.store = store;
        this.authService = authService;
        this.router = router;
        this.store.dispatch(SearchPrioritiesAction.dispatch({}));
        this.store.dispatch(LoadConfigurationAction.dispatch());
        this.me = this.store.selectSnapshot(GlobalState.me);
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            this.visible = false;
        });
    }
    ngOnInit() {
        if (this.authService.isAdmin) {
            this.items = [...adminMenuItems];
            return;
        }
        if (this.authService.isEditor) {
            this.items = [...editorMenuItems];
            return;
        }
        if (this.authService.isExternal || this.authService.isDesigner) {
            this.items = [...externalMenuItems];
            return;
        }
        if (this.authService.isCustomer) {
            this.items = [...customerMenuItems];
            return;
        }
    }
    logout() {
        this.authService.logout();
    }
    setChatVisibility(b) {
        this.store.dispatch(SetChatVisibilityAction.dispatch(true));
    }
    toggleDrawer(b) {
        if (b !== undefined) {
            this.visible = b;
            return;
        }
        this.visible = !this.visible;
    }
    toggleSpeeddial() {
        this.showSpeeddial = !this.showSpeeddial;
    }
    static ɵfac = function BaseComponent_Factory(t) { return new (t || BaseComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.AuthService), i0.ɵɵdirectiveInject(i3.Router)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BaseComponent, selectors: [["mvm-base"]], decls: 3, vars: 3, consts: () => { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG_EXTERNAL_9184023831874854128$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_0 = goog.getMsg("Odjava");
            i18n_0 = MSG_EXTERNAL_9184023831874854128$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_0;
        }
        else {
            i18n_0 = $localize `Odjava`;
        } let i18n_1; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG_EXTERNAL_7492383260644747129$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_1 = goog.getMsg("Novo naro\u010Dilo");
            i18n_1 = MSG_EXTERNAL_7492383260644747129$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_1;
        }
        else {
            i18n_1 = $localize `Novo naročilo`;
        } let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG_EXTERNAL_1470476207303282205$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_2 = goog.getMsg("Organizator");
            i18n_2 = MSG_EXTERNAL_1470476207303282205$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_2;
        }
        else {
            i18n_2 = $localize `Organizator`;
        } let i18n_3; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG_EXTERNAL_2638879225202017189$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_3 = goog.getMsg("Koledar");
            i18n_3 = MSG_EXTERNAL_2638879225202017189$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_3;
        }
        else {
            i18n_3 = $localize `Koledar`;
        } let i18n_4; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG_EXTERNAL_5438218023471144450$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_4 = goog.getMsg("Odlo\u017Ei\u0161\u010De");
            i18n_4 = MSG_EXTERNAL_5438218023471144450$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_4;
        }
        else {
            i18n_4 = $localize `Odložišče`;
        } let i18n_5; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG_EXTERNAL_9184023831874854128$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_5 = goog.getMsg("Odjava");
            i18n_5 = MSG_EXTERNAL_9184023831874854128$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_5;
        }
        else {
            i18n_5 = $localize `Odjava`;
        } let i18n_6; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG_EXTERNAL_9184023831874854128$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_6 = goog.getMsg("Odjava");
            i18n_6 = MSG_EXTERNAL_9184023831874854128$$APPS_MVM_SRC_APP_BASE_BASE_COMPONENT_TS_6;
        }
        else {
            i18n_6 = $localize `Odjava`;
        } return [["headless", ""], [3, "model"], ["pTemplate", "start"], ["pTemplate", "end"], [1, "main"], ["src", "/assets/printcore.png", "alt", "Logo", 1, "menubar-logo", 3, "routerLink"], [1, "flex", "align-items-center"], [1, "user-container"], [1, "avatar", "sm:none", "md:block", 3, "src", "alt"], [1, "user-data", "md:inline-flex", "sm:hidden"], [1, "name"], [1, "email"], ["pButton", "", "type", "button", "label", i18n_0, "icon", "fa-solid fa-arrow-right-from-bracket", 1, "mr-2", 3, "click"], ["icon", "fa-solid fa-bars", 1, "menubutton", 3, "mouseenter", "click"], [3, "visibleChange", "visible", "dismissible"], [1, "drawer", "h-full", "w-full", 3, "mouseleave"], [1, "drawer-header"], [1, "md:flex", "sm:hidden", "text-small", "flex-column", "justify-content-center", "align-items-center", "flex-shrink-0"], [1, "name", "font-bold"], [1, "drawer-quick"], ["icon", "fa-solid fa-plus", "pTooltip", i18n_1, 3, "click"], ["icon", "fa-solid fa-table", "pTooltip", i18n_2, 3, "click"], ["icon", "fa-solid fa-calendar", "pTooltip", i18n_3, 3, "click"], ["icon", "fa-solid fa-paste", "pTooltip", i18n_4, 3, "click"], [1, "drawer-content"], [1, "drawer-footer"], ["icon", "fa-solid fa-arrow-right-from-bracket", "severity", "danger", "pTooltip", i18n_5, "label", i18n_6, 3, "click"], ["class", "fa fa-message chat-icon cursor-pointer", 3, "new-message", "click", 4, "ngIf"], [4, "ngIf"], [1, "fa", "fa-message", "chat-icon", "cursor-pointer", 3, "click"]]; }, template: function BaseComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, BaseComponent_Conditional_0_Template, 5, 1)(1, BaseComponent_Conditional_1_Template, 6, 2)(2, BaseComponent_Conditional_2_Template, 5, 6, "ng-container");
        } if (rf & 2) {
            i0.ɵɵconditional(ctx.layout !== "new" ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.layout === "new" ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.environment.layout === "new" ? 2 : -1);
        } }, dependencies: [i4.ButtonDirective, i4.Button, i5.PrimeTemplate, i6.NgIf, i7.Menubar, i8.Tooltip, i9.PanelMenu, i10.Drawer, i3.RouterOutlet, i3.RouterLink, i11.ChatWindowComponent, i6.AsyncPipe], styles: ["[_nghost-%COMP%] {\n  position: relative;\n}\n\n.main[_ngcontent-%COMP%] {\n  padding-top: 4rem;\n}\n\np-speeddial[_ngcontent-%COMP%] {\n  position: absolute;\n  z-index: 10;\n}\n\n  .p-menubar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  z-index: 9;\n  height: 50px;\n}\n  .p-menubar .menubar-logo {\n  display: block;\n  height: 20px;\n  margin: 0 30px 0 10px;\n  cursor: pointer;\n}\n  .p-menubar .user-container {\n  display: inline-flex;\n  margin-right: 20px;\n  justify-content: center;\n}\n  .p-menubar .user-container .avatar {\n  height: 30px;\n  margin-right: 13px;\n  border-radius: 50%;\n}\n@media screen and (max-width: 768px) {\n    .p-menubar .user-container .avatar {\n    display: none;\n  }\n}\n  .p-menubar .user-container .user-data {\n  display: inline-flex;\n  flex-direction: column;\n}\n@media screen and (max-width: 768px) {\n    .p-menubar .user-container .user-data {\n    display: none;\n  }\n}\n  .p-menubar .user-container .user-data .name,   .p-menubar .user-container .user-data .email {\n  display: inline-flex;\n  justify-content: flex-start;\n}\n  .p-menubar .user-container .user-data .name {\n  font-size: 13px;\n  font-weight: 500;\n}\n  .p-menubar .user-container .user-data .email {\n  font-size: 12px;\n  font-weight: 700;\n  margin-top: 2px;\n}\n\n.bottom-bar[_ngcontent-%COMP%] {\n  display: flex;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #ffffff;\n  border-top: 1px solid #d8dce6;\n  height: 50px;\n  box-shadow: 0 -2px 5px 0 rgba(0, 0, 0, 0.05);\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 25px;\n}\n.bottom-bar[_ngcontent-%COMP%]   .start[_ngcontent-%COMP%], .bottom-bar[_ngcontent-%COMP%]   .end[_ngcontent-%COMP%] {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n.bottom-bar[_ngcontent-%COMP%]   .end[_ngcontent-%COMP%]   .price[_ngcontent-%COMP%] {\n  margin-left: 35px;\n}\n.bottom-bar[_ngcontent-%COMP%]   .end[_ngcontent-%COMP%]   .price[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%] {\n  margin-right: 5px;\n}\n.bottom-bar[_ngcontent-%COMP%]   .end[_ngcontent-%COMP%]   .price[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%] {\n  font-weight: 500;\n}\n\n.chat-icon[_ngcontent-%COMP%] {\n  position: fixed;\n  bottom: 1rem;\n  right: 1rem;\n  font-size: 2rem;\n}\n\n@keyframes _ngcontent-%COMP%_blink {\n  50% {\n    opacity: 0;\n    transform: scale(1.2);\n  }\n}\n.new-message[_ngcontent-%COMP%] {\n  color: #A2C950;\n  animation: _ngcontent-%COMP%_blink 1.4s linear infinite;\n}\n\n.menubutton[_ngcontent-%COMP%] {\n  position: absolute;\n  z-index: 100 !important;\n  left: 0.1rem;\n  top: 0.1rem;\n}\n\n.drawer[_ngcontent-%COMP%] {\n  display: flex;\n  flex-direction: column;\n  z-index: 6000 !important;\n  overflow-y: auto;\n}\n.drawer[_ngcontent-%COMP%]   .drawer-header[_ngcontent-%COMP%] {\n  padding: 0.5rem 0.5rem;\n  justify-content: center;\n  border-bottom: 1px solid var(--p-primary-50);\n  margin-bottom: 0.5rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n.drawer[_ngcontent-%COMP%]   .drawer-header[_ngcontent-%COMP%]   img[_ngcontent-%COMP%] {\n  border-radius: 50% 50%;\n  max-width: 50px;\n  max-height: 50px;\n  width: 50px;\n  height: 50px;\n}\n.drawer[_ngcontent-%COMP%]   .drawer-quick[_ngcontent-%COMP%] {\n  padding: 0.5rem 0 1rem 0;\n  justify-content: center;\n  align-items: center;\n  border-bottom: 1px solid var(--p-primary-50);\n  margin-bottom: 0.5rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n.drawer[_ngcontent-%COMP%]   .drawer-content[_ngcontent-%COMP%] {\n  padding: 0.5rem 0.5rem;\n  flex-grow: 1;\n}\n.drawer[_ngcontent-%COMP%]   .drawer-footer[_ngcontent-%COMP%] {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  padding-bottom: 0.5rem;\n}"] });
}
